module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-512x512-52168ca8c8cc4abd3b5ba0e54fae56c9.png";